import { Alignment, Button, Classes, Dialog, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IProduto } from "../../model";
import { ProdutoStore } from "../../stores/legislacao/ProdutoStore";
import { sortBy } from "../../utils";
import { MDBBtn } from "mdbreact";
import InfiniteScroll from "react-infinite-scroll-component";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
const numeral = require("numeral");
var debounce = require('lodash.debounce');

interface ProdutoSelectProps {
  entrada_saida: string;
  estado: string;
  value: string[];
  onChange(value: string[]): void;
}

interface ProdutoSelectState {}

@observer
export class ProdutoSelect extends React.Component<ProdutoSelectProps, ProdutoSelectState> {

  obs = observable({
    value: [] as IProduto[],
    isOpen: false as boolean,
    filter: "" as string,
    filter_added: "" as string,
    loading: false as boolean,
    page: 1 as number,
    hasMore: true as boolean,
    options: [] as IProduto[],
    fetchOptions: {} as any
  });

  constructor(props: ProdutoSelectProps) {
    super(props);

    this.obs.fetchOptions = debounce(this.fetchOptions.bind(this), 800);

  }

  async fetchOptions(inputValue: string, page: number) {

    this.obs.loading = true;

    try {

      this.obs.filter = inputValue

      const result: any = await ProdutoStore.load(page, inputValue, this.props.entrada_saida, this.props.estado);

      if (result.length > 0) {

        this.obs.options = [...this.obs.options, ...result];
        this.obs.page = page;
        this.obs.hasMore = true

      } else {

        this.obs.hasMore = false;

      }

    } catch (error) {

      console.error('Erro ao buscar dados:', error);

    }

    this.obs.loading = false;

  }

  handleClick = async () => {

    this.obs.options = [];
    this.obs.page = 1;
    this.obs.hasMore = true;

    await this.fetchOptions("", 1);

    this.updateValues();

    this.obs.isOpen = true;

  };

  updateValues() {

    this.obs.value = [];

    this.props.value?.forEach(async id => {

      let produto = await ProdutoStore.get(id);

      if (produto) {

        this.obs.value.push(produto);

      }

    });

    this.obs.value = sortBy(this.obs.value, "cest");

  }

  handleClose = () => {

    this.obs.isOpen = false;

  };

  handleConfirm = () => {
    this.props.onChange(this.obs.value?.map(p => p.id));
    this.obs.isOpen = false;
  };

  handleRemove(item: IProduto) {
    let idx = this.obs.value.findIndex(x => x.id == item.id);
    if (idx != -1) {
      this.obs.value.splice(idx, 1);
    }
  }

  handleSelect = (event: any, item: IProduto | null) => {

    if (item && !this.obs.value.find(x => x.id == item.id)) {

      this.obs.value.push(item);

    }

  };

  handleScroll = (event: any) => {

    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;

    if (bottom && this.obs.hasMore) {

      this.fetchOptions(this.obs.filter, this.obs.page + 1);

    }

  };

  fetchMoreAvisos = async () => { };

  render() {
    let items = this.obs.value;

    if (this.obs.filter_added) {
      items = items.filter(x =>
        x.descricao.toUpperCase().indexOf(this.obs.filter_added.toUpperCase()) != -1 ||
        x.cest.toUpperCase().indexOf(this.obs.filter_added.toUpperCase()) != -1 ||
        x.ncm.toUpperCase().indexOf(this.obs.filter_added.toUpperCase()) != -1
      );
    }

    let rows = this.obs.value?.map(value => {
      return (
        <tr key={value._id}>
          <td>{value.ncm}</td>
          <td>{value.cest}</td>
          <td>{value.descricao}</td>
          <td>{
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleRemove.bind(this, value)}
            >
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
          }</td>
        </tr>
      );
    });

    return (
      <>
        <Button
          text={`${numeral(this.props.value.length).format()} produto(s) seleciondo(s)`}
          rightIcon="multi-select"
          alignText={Alignment.LEFT}
          onClick={this.handleClick}
          className="multiSelect"
        />

        <Dialog
          isOpen={this.obs.isOpen}
          title="Selecionar Produtos"
          enforceFocus={false}
          onClose={this.handleClose}
          canOutsideClickClose={false}
          style={{ width: 900 }}
        >
          <div className={Classes.DIALOG_BODY} style={{ height: 400 }}>
            <div style={{ display: "flex", alignItems: "center" }}>

              <Autocomplete
                disablePortal
                size="small"
                options={this.obs.options}
                onInputChange={(event, value) => {
                  this.obs.options = [];
                  this.obs.page = 1;
                  this.obs.hasMore = true;
                  this.obs.fetchOptions(value, 1);
                }}
                getOptionLabel={(option) => `${option.ncm} - ${option.cest} - ${option.descricao}` || ""}
                onChange={this.handleSelect}
                ListboxProps={{ onScroll: this.handleScroll }}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Pesquisar"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {this.obs.loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                value={null}
                className='select-empresas'
                clearOnBlur
                clearOnEscape
                blurOnSelect
                noOptionsText="Não foram encontrados resultados!"
              />

              <InputGroup
                style={{ marginLeft: 10, width: 200 }}
                placeholder="Filtrar (Código, Descrição)"
                value={this.obs.filter_added}
                onChange={(e: any) => this.obs.filter_added = e.target.value}
              />
            </div>

            <div style={{ marginTop: 15, marginBottom: 15 }}>
              {this.obs.value.length} itens selecionado(s)
            </div>

            <InfiniteScroll
              dataLength={this.obs.value.length}
              next={this.fetchMoreAvisos}
              hasMore={true}
              height={300}
              loader={ProdutoStore.obs.loading ?
                <div style={{ textAlign: "center" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
                : ""}
            >
              <div className="table-container">
                <table className="table table-hover dataTable custom-table">
                  <thead className="sticky-header">
                    <tr>
                      <th className="column-width-code">CÓDIGO</th>
                      <th className="column-width-code">CEST</th>
                      <th className="column-width-description">DESCRIÇÃO</th>
                      <th className="column-width-code" />
                    </tr>
                  </thead>
                  <tbody>
                    {rows}
                  </tbody>
                </table>
              </div>

            </InfiniteScroll>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={this.handleClose} />
              <Button text="Salvar" onClick={this.handleConfirm} intent="primary" />
            </div>
          </div>

        </Dialog>
      </>
    );
  }
}

